import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Hero.css';

// Import all hero images
import heroImage1 from '../assets/images/hero_images/1.jpg';
import heroImage2 from '../assets/images/hero_images/2.jpg';
import heroImage3 from '../assets/images/hero_images/3.jpg';
import heroImage4 from '../assets/images/hero_images/4.jpg';
import heroImage5 from '../assets/images/hero_images/5.jpg';
import heroImage6 from '../assets/images/hero_images/6.jpg';
import heroImage7 from '../assets/images/hero_images/7.jpg';
import heroImage8 from '../assets/images/hero_images/8.jpg';

const Hero: React.FC = () => {
  // Array of all hero images
  const heroImages = [
    heroImage1, heroImage2, heroImage3, heroImage4,
    heroImage5, heroImage6, heroImage7, heroImage8
  ];

  // State to track current image index and loading status
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [loadedImages, setLoadedImages] = useState<boolean[]>(new Array(heroImages.length).fill(false));

  // Preload images
  useEffect(() => {
    const preloadImages = async () => {
      const loadPromises = heroImages.map((src, index) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = () => {
            setLoadedImages(prev => {
              const newState = [...prev];
              newState[index] = true;
              return newState;
            });
            resolve(true);
          };
        });
      });

      await Promise.all(loadPromises);
      setImagesLoaded(true);
    };

    preloadImages();
  }, []);

  // Effect to rotate images
  useEffect(() => {
    if (!imagesLoaded) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [heroImages.length, imagesLoaded]);

  return (
    <section
      id="home"
      className="hero"
      style={{
        backgroundImage: imagesLoaded ? `url(${heroImages[currentImageIndex]})` : 'none',
        transition: 'none'
      }}
    >
      <div className="hero-overlay"></div>
      <div className="container hero-content">
        <h1 className="hero-tagline">The Collective at Gateway</h1>
        <p className="hero-description">Premium Flexible Office Space Solutions</p>
      </div>
      <div className="hero-mask"></div>
    </section>
  );
};

export default Hero; 